import * as React from "react";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { AiOutlineDown } from "react-icons/ai";

export default function MenuButton({ list, label, setLabel }) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <Button
        color="inherit"
        id="basic-button"
        aria-controls={open ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
        className=" fw-bold d-flex gap-2 resFont"
        
      >
        {label} <AiOutlineDown/>
      </Button>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        {list?.map((li, index) => {
          return (
            <MenuItem
              key={index}
              onClick={() => {
                setLabel(li === "Completed" ? 'Completed': 'Current');
                handleClose();
              }}
            >
              {li}
            </MenuItem>
          );
        })}
      </Menu>
    </div>
  );
}
